module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-telefone-step"
  }, [_c('h2', {
    staticClass: "aso-telefone-step__title"
  }, [_vm._v("Termine a validação pelo seu celular.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-telefone-step__text"
  }, [_vm._v("Você receberá um token por SMS para continuar.")]), _vm._v(" "), _c('input', {
    staticClass: "aso-telefone-step__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "maxlength": "15",
      "placeholder": "(00) 00000-0000",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.telefone
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:telefone', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "aso-telefone-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canContinue
    },
    on: {
      "click": function($event) {
        return _vm.$emit('continue')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Enviando...' : 'Continuar') + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e377a790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/AsoValidarTelefoneStep.vue
// module id = 1506
// module chunks = 45